export default __webpack_public_path__ + "static/media/36I-114280_-20497_0.d86071c1.jpg";